export { DynamicAssetTemplate } from './DynamicAssetTemplate';
export { FlexTemplate } from './FlexTemplate';
export { ImageTemplate } from './ImageTemplate';
export { MapTemplate } from './MapTemplate';
export { SummaryTemplate } from './SummaryTemplate';